 document.addEventListener("DOMContentLoaded", function () {
    const ctaButtons = document.querySelectorAll(".get-price");
    const targetSection = document.getElementById("wcl-pricing-plan");

    if (ctaButtons.length > 0 && targetSection) {
        ctaButtons.forEach(btn => {
            btn.addEventListener("click", function (e) {
                e.preventDefault();

                targetSection.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            });
        });
    }
});